export default "__VITE_ASSET__ea7c4d28__"